import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../../../../../app.settings';


@Injectable({
  providedIn: 'root'
})
export class EmailconfigService {

 // Base_Url = ' http://mtrx-svr928.matrix.local/api/';
 Base_Url = `${AppSettings.EMAIL_API_ENDPOINT}`;
  topicKeywordUrl = `${this.Base_Url}/${'config'}`;
  saveTopicUrl = `${this.Base_Url}/${'config'}`;
  clientUrl = `${this.Base_Url}/${'client'}`;
  callTypeUrl = `${this.Base_Url}/${'call_type'}`;
  errorTypeUrl = `${this.Base_Url}/${'error_type'}`;
  createCategoryUrl = `${this.Base_Url}/${'config/category'}`;
  getQaParam_baseConfig_Url = `${this.Base_Url}/${'config/qa-param'}`;
  updateTopicUrl = `${this.Base_Url}/${'save-topic'}`;
  deleteTopicUrl = `${this.Base_Url}/${'delete-keywords'}`;
  surveyUrl = `${this.Base_Url}/${'get-survey-config'}`;
  stopWordUrl = `${this.Base_Url}/${'get-stopwords'}`;
  emailConfigUrl = `${this.Base_Url}/${'email-config'}`;
  updateEmailConfigUrl = `${this.Base_Url}/${'email-config-update'}`;
  updateStopWordUrl = `${this.Base_Url}/${'update-stopwords'}`;

  autoReplyEmailTemplateUrl=`${this.Base_Url}/${'templates'}`;
    mailServerConfigUrl = `${this.Base_Url}/${'settings'}`;
  
  
  constructor(private http: HttpClient) { }

  getTopicKeyword(){
    return this.http.get(this.topicKeywordUrl);
  }

  saveTopics(data:any){
     return this.http.post(this.saveTopicUrl, data);
  }

  updateTopic(data:any){
    return this.http.put(`${this.saveTopicUrl}`,data);
  }

  deleteTopicData(id:any){
    return this.http.delete(`${this.saveTopicUrl}/${id}`);
  }

  getSurvey(){
    return this.http.get(this.surveyUrl);
  }

  getStopWord(word:string){
    return this.http.get(`${this.stopWordUrl}/${word}`);
  }

  getEmailConfiguration(){
    return this.http.get(this.emailConfigUrl);
  }

  updateEmailConfiguration(data:any){
    return this.http.post(this.updateEmailConfigUrl, data);
  }

  updateStopWord(data:any){
    return this.http.post(this.updateStopWordUrl, data);
  }

   createCategory(payload:any){
     return this.http.post(this.createCategoryUrl,payload);
   }

   updateCategory(payload:any){
    return this.http.put(this.createCategoryUrl,payload);
  }

  deleteCategory(category_id:any){
    return this.http.delete(`${this.createCategoryUrl}/${category_id}`);
  }

   getCategory(config_id:any){
      return this.http.get(`${this.createCategoryUrl}/${config_id}`);
   }

   getQaParameter(config_id:any){
    return this.http.get(`${this.getQaParam_baseConfig_Url}/${config_id}`);
   }

   deleteQaParameter(config_id:any,qa_param_id:any){
    return this.http.delete(`${this.getQaParam_baseConfig_Url}/${config_id}/${qa_param_id}`);
   }

   createQaParameter(payload:any){
    return this.http.post(this.getQaParam_baseConfig_Url,payload);
  }

  updateQaParameter(payload:any){
    return this.http.put(this.getQaParam_baseConfig_Url,payload);
  }

  getErrortypes(){
    return this.http.get(this.errorTypeUrl);
  }

  getClient(){
    return this.http.get(this.clientUrl);
  }

  getCallType(){
    return this.http.get(this.callTypeUrl);
  }

  createAutoReplyEmailTemplate(payload:any,client_id:any){
    return this.http.post(this.autoReplyEmailTemplateUrl+"/"+client_id,payload);
  }

  getAutoReplyEmailTemplate(client_id:any){
     return this.http.get(this.autoReplyEmailTemplateUrl+"/client/"+client_id);
  }

  getAutoReplyEmailTemplateById(_id:any){
    return this.http.get(this.autoReplyEmailTemplateUrl+'/template/'+_id);
  }

  updateAutoReplyEmailTemplate(payload:any,id:any){
    return this.http.put(this.autoReplyEmailTemplateUrl+'/'+id,payload);
  }

  deleteAutoReplyEmailTemplate(id:any){
    return this.http.delete(this.autoReplyEmailTemplateUrl+'/'+id);
  }

  getMailConfigSettings(){
    return this.http.get(this.mailServerConfigUrl);
  }

  saveMailConfigSettings(payload:any){
    return this.http.post(this.mailServerConfigUrl,payload);
  }
  
}
